
export default {
  name: "CarouselIndicators",
  emits: ["switch"],
  props: ["total", "currentIndex"],
};
